<div style="width: 100%; height: 100%; position: relative">
  <!-- <app-skeleton-content-panel-vehicle
    *ngIf="isLoadingOldService"
  ></app-skeleton-content-panel-vehicle>

  <app-bg-loading-content-panel
    *ngIf="isLoadingOldService && isFirstTimeLoad"
  ></app-bg-loading-content-panel> -->

  <ng-container *ngIf="unitsCollection$ | async as unitsCollection">
    <section
      class="section_panel"
      *ngIf="
        !isLoadingCollection &&
        !isLoadingVehicleService &&
        !(isLoadingStateVehicle$ | async)
      "
    >
      <app-toolbar
        (eventDisplayGroup)="onClickGroup()"
        (eventKeyUpToFilter)="getValueFromKeyUpEvent($event)"
      ></app-toolbar>
      <app-checkbox-container-vehicle
        *ngIf="servicePanel.showCheckbox$ | async"
        (disabledFollow)="onDisabledFollow()"
        (disabledFormatedOperation)="onDisabledFormatedOperation($event)"
        (disabledFilterEye)="onDisabledFilterEye($event)"
      ></app-checkbox-container-vehicle>

      <app-divider-vehicle style="opacity: 0"></app-divider-vehicle>

      <div *ngIf="isFormatedOperation" class="main_content">
        <div
          *ngIf="unitsCollection.length === 0"
          class="d-flex justify-content-center align-items-center h-100"
        >
          <span class="text-muted"
            >No hay unidades disponibles para mostrar</span
          >
        </div>
        <app-vehicle-collection
          *ngFor="let operation of unitsCollection; trackBy: trackByOperation"
          [typeCollection]="operation.nameOperation"
          [nameCollection]="
            operation.idOperation === 0 ? 'Unidades ' : 'Operación: '
          "
          variant="operacion"
          [id]="{ idOperation: operation.idOperation }"
          (eventDisplayCollection)="changeDisplay($event)"
          (eventDeleteCollection)="showDelete($event)"
          (eventEditCollection)="showEditGroup($event)"
          (eventMultiviewCollection)="followVehicles($event)"
          [isOpen]="true"
        >
          <app-vehicle-collection
            *ngFor="let group of operation.groups; trackBy: trackByGroup"
            [typeCollection]="group.nameGroup"
            [nameCollection]="group.idGrupo === 0 ? 'Unidades ' : 'Grupo: '"
            variant="grupo"
            [id]="{
              idOperation: operation.idOperation,
              idGroup: group.idGrupo
            }"
            (eventDisplayCollection)="changeDisplay($event)"
            (eventDeleteCollection)="showDelete($event)"
            (eventEditCollection)="showEditGroup($event)"
            (eventMultiviewCollection)="followVehicles($event)"
            [isOpen]="true"
          >
            <app-vehicle-collection
              *ngFor="let convoy of group.convoys; trackBy: trackByConvoy"
              [typeCollection]="convoy.nameConvoy"
              [nameCollection]="
                convoy.idConvoy === 0 ? 'Unidades ' : 'Convoy: '
              "
              variant="convoy"
              [id]="{
                idOperation: operation.idOperation,
                idGroup: group.idGrupo,
                idConvoy: convoy.idConvoy
              }"
              (eventDisplayCollection)="changeDisplay($event)"
              (eventDeleteCollection)="showDelete($event)"
              (eventEditCollection)="showEditGroup($event)"
              (eventMultiviewCollection)="followVehicles($event)"
              [isOpen]="true"
            >
              <app-card-vehicle
                *ngFor="let unit of convoy.units; trackBy: trackByUnit"
                [idCard]="'card-vehicle-' + unit.device.IMEI"
                [primaryName]="
                  (servicePanel.showNameItemButton$ | async)
                    ? unit.unitName
                    : (servicePanel.showInternalCodeItemButton$ | async)
                    ? unit.internalCode
                    : (servicePanel.showNamePlateItemButton$ | async)
                    ? unit.licensePlate
                    : 'No definido'
                "
                [IMEI]="unit.device.IMEI"
                [date]="unit.device.trackerDate"
                [location]="unit.device.SIMNumber"
                [transmissionStatus]="unit.transmissionStatusId"
                [speed]="{ value: unit.device.speed || 0, measurement: 'km/h' }"
                [batteryVoltage]="{
                  value: unit.device.batteryVoltage || 0,
                  measurement: 'V'
                }"
                [amountOfFuel]="{
                  value: unit.device.IOs.can_dist || 0,
                  measurement: 'gal'
                }"
                [timeElapsed]="
                  convertSecondsToTimeString(unit.elapsedTime)
                "
                [hasIgnition]="unit.hasIgnition"
                [satelliteCount]="unit.device.satelliteCount"
                [temperatureBLE]="getTemperatureBleTemperature(unit)"
                [temperatureEYE]="getTemperatureEyeTemperature(unit)"
                [humidityBLE]="getHumidityBle(unit)"
                [humidityEYE]="getHumidityEye(unit)"
                [secondInformation]="getNameDriverByImei(unit.device.IMEI)"
                [unitType]="unit.unitType"
                [urlIcon]="unit.tramsmissionIcon"
                [unitDetails]="[
                  {
                    label: 'VEHICLES.CARD.DETAIL.NAME' | translate,
                    value: unit.unitName,
                    variant: editUnitName ? 'edit' : 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.SIM_NUMBER' | translate,
                    value: unit.device.SIMNumber,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.COMPANY' | translate,
                    value: unit.company,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.OPERATION' | translate,
                    value: unit.operation,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.GROUP' | translate,
                    value: unit.group,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.CONVOY' | translate,
                    value: unit.convoy,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.INTERNAL_CODE' | translate,
                    value: unit.internalCode,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.IMEI' | translate,
                    value: unit.device.IMEI,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.PLATE' | translate,
                    value: unit.licensePlate,
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.DRIVER' | translate,
                    value: getNameDriverByImei(unit.device.IMEI),
                    variant: 'default'
                  },
                  {
                    label: 'VEHICLES.CARD.DETAIL.UNIT_TYPE' | translate,
                    value: unit.unitType,
                    variant: 'default'
                  }
                ]"
                [iosDetail]="adaptDetailIos(unit.device.IOs, unit)"
                [isExpanded]="isCardExpanded(unit.device.IMEI)"
                (toggleExpanded)="toggleCard(unit.device.IMEI)"
                [viewOptionVisible]="isViewOptionVisible(unit.device.IMEI)"
                (toggleVisible)="toggleVisible(unit.device.IMEI)"
                (setTrueVisible)="setTrueVisible(unit.device.IMEI)"
                [viewOptionFollow]="isViewOptionFollow(unit.device.IMEI)"
                (toggleFollow)="toggleFollow(unit.device.IMEI)"
                [viewOptionShowDriver]="
                  isViewOptionShowDriver(unit.device.IMEI)
                "
                (toggleShowDriver)="toggleShowDriver(unit.device.IMEI)"
                [viewOptionShowName]="isViewOptionShowName(unit.device.IMEI)"
                (toggleShowName)="toggleShowName(unit.device.IMEI)"
              ></app-card-vehicle>
            </app-vehicle-collection>
          </app-vehicle-collection>
        </app-vehicle-collection>
      </div>

      <ng-container
        *ngIf="unitsWithTransmission$ | async as unitsWithTransmission"
      >
        <div *ngIf="!isFormatedOperation" style="height: 100%">
          <div
            *ngIf="unitsWithTransmission.length === 0"
            class="d-flex justify-content-center align-items-center h-100"
          >
            <span class="text-muted"
              >No hay unidades disponibles para mostrar</span
            >
          </div>
          <cdk-virtual-scroll-viewport
            class="main_content"
            style="
              height: calc(
                100dvh - 175px -
                  calc(var(--navbar-height) + var(--footbar-height)) +
                  calc(var(--container-transmission-height) + var(--container-vehicle-display-height))
              );
            "
            [itemSize]="100"
          >
            <app-card-vehicle
              *cdkVirtualFor="
                let unit of unitsWithTransmission;
                trackBy: trackByUnit
              "
              [idCard]="'card-vehicle-' + unit.device.IMEI"
              [primaryName]="
                (servicePanel.showNameItemButton$ | async)
                  ? unit.unitName
                  : (servicePanel.showInternalCodeItemButton$ | async)
                  ? unit.internalCode
                  : (servicePanel.showNamePlateItemButton$ | async)
                  ? unit.licensePlate
                  : 'No definido'
              "
              [IMEI]="unit.device.IMEI"
              [date]="unit.device.trackerDate"
              [location]="unit.device.SIMNumber"
              [transmissionStatus]="unit.transmissionStatusId"
              [speed]="{ value: unit.device.speed || 0, measurement: 'km/h' }"
              [batteryVoltage]="{
                value: unit.device.batteryVoltage || 0,
                measurement: 'V'
              }"
              [amountOfFuel]="{
                value: unit.device.IOs.can_dist || 0,
                measurement: 'gal'
              }"
              [timeElapsed]="convertSecondsToTimeString(unit.elapsedTime)"
              [hasIgnition]="unit.hasIgnition"
              [satelliteCount]="unit.device.satelliteCount"
              [temperatureBLE]="getTemperatureBleTemperature(unit)"
              [temperatureEYE]="getTemperatureEyeTemperature(unit)"
              [humidityBLE]="getHumidityBle(unit)"
              [humidityEYE]="getHumidityEye(unit)"
              [secondInformation]="getNameDriverByImei(unit.device.IMEI)"
              [unitType]="unit.unitType"
              [urlIcon]="unit.tramsmissionIcon"
              [unitDetails]="[
                {
                  label: 'VEHICLES.CARD.DETAIL.NAME' | translate,
                  value: unit.unitName,
                  variant: editUnitName ? 'edit' : 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.SIM_NUMBER' | translate,
                  value: unit.device.SIMNumber,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.COMPANY' | translate,
                  value: unit.company,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.OPERATION' | translate,
                  value: unit.operation,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.GROUP' | translate,
                  value: unit.group,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.CONVOY' | translate,
                  value: unit.convoy,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.INTERNAL_CODE' | translate,
                  value: unit.internalCode,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.IMEI' | translate,
                  value: unit.device.IMEI,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.PLATE' | translate,
                  value: unit.licensePlate,
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.DRIVER' | translate,
                  value: getNameDriverByImei(unit.device.IMEI),
                  variant: 'default'
                },
                {
                  label: 'VEHICLES.CARD.DETAIL.UNIT_TYPE' | translate,
                  value: unit.unitType,
                  variant: 'default'
                }
              ]"
              [iosDetail]="adaptDetailIos(unit.device.IOs, unit)"
              [isExpanded]="isCardExpanded(unit.device.IMEI)"
              (toggleExpanded)="toggleCard(unit.device.IMEI)"
              [viewOptionVisible]="isViewOptionVisible(unit.device.IMEI)"
              (toggleVisible)="toggleVisible(unit.device.IMEI)"
              (setTrueVisible)="setTrueVisible(unit.device.IMEI)"
              [viewOptionFollow]="isViewOptionFollow(unit.device.IMEI)"
              (toggleFollow)="toggleFollow(unit.device.IMEI)"
              [viewOptionShowDriver]="isViewOptionShowDriver(unit.device.IMEI)"
              (toggleShowDriver)="toggleShowDriver(unit.device.IMEI)"
              [viewOptionShowName]="isViewOptionShowName(unit.device.IMEI)"
              (toggleShowName)="toggleShowName(unit.device.IMEI)"
            >
            </app-card-vehicle>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-container>

      <app-divider-vehicle style="opacity: 1"></app-divider-vehicle>

      <div class="button-toggle-container-container">
        <app-button-toggle-container
          *ngIf="servicePanel.showTransmissionStatus$ | async"
          (onClick)="onClickButtonToggleContainer($event)"
          [transmissionStatusInformation]="transmissionStatus$ | async"
        ></app-button-toggle-container>
      </div>
    </section>
  </ng-container>

  <p-dialog
    header=""
    icon="pi pi-info-circle"
    [style]="{ width: '50vw' }"
    [(visible)]="displayEditGroup"
    [modal]="true"
    [resizable]="false"
  >
    <ng-template class="p-dialog-title" pTemplate="header">
      <div>
        <i class="fa fa-pencil me-2" aria-hidden="true"></i>
        <strong>Editar {{ textHeaderEdit }}</strong>
      </div>
    </ng-template>
    <div class="dialog-body-container">
      <div class="p-fluid p-formgrid p-grid">
        <div class="dialog-form-container">
          <div class="row gl-out-middleline">
            <div class="col p-field p-0">
              <div class="row gl-row-underline m-0 w-100">
                <div
                  class="col-5 d-flex align-items-center justify-content-start text-start fw-bold"
                >
                  <label for="float-input">Nombre:</label>
                </div>
                <div class="col-7">
                  <input
                    #nameEdit
                    id="float-input"
                    type="text"
                    pInputText
                    class="p-inputtext-sm"
                    placeholder=""
                    [disabled]="loading"
                    [readonly]="readonlyNameGroup"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="flex-column mt-3">
            <div class="row gl-listbox-container">
              <div class="col">
                <p-listbox
                  [options]="list1"
                  [(ngModel)]="selectedList1"
                  [multiple]="true"
                  [checkbox]="true"
                  [filter]="true"
                  [filterPlaceHolder]="
                    ('VEHICLES.SEARCH.BY_PLATE' | translate) + ':'
                  "
                  optionLabel="name"
                  [listStyle]="{ height: '200px' }"
                  [disabled]="loading"
                >
                  <ng-template let-car pTemplate="item">
                    <div class="car-item">
                      <img
                        border="0"
                        width="25"
                        height="25"
                        [src]="car.sanitizer_custom_svg"
                        style="display: inline-block; margin: 2px 0 2px 2px"
                      />

                      <label>{{ car.name }}</label>
                    </div>
                  </ng-template>
                </p-listbox>
              </div>

              <div
                class="col-1 d-flex flex-column justify-content-center align-items-center"
              >
                <div style="height: 1.5rem"></div>
                <div class="">
                  <button
                    (click)="upList2()"
                    type="button"
                    class="btn btn-gl-light-blue btn-circle"
                    name="button"
                    [disabled]="loading"
                  >
                    <span>
                      <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div style="height: 1rem"></div>
                <div class="">
                  <button
                    (click)="upList1()"
                    type="button"
                    class="btn btn-gl-light-blue btn-circle"
                    name="button"
                    [disabled]="loading"
                  >
                    <span>
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="col">
                <p-listbox
                  [options]="list2"
                  [(ngModel)]="selectedList2"
                  [multiple]="true"
                  [checkbox]="true"
                  [filter]="true"
                  [filterPlaceHolder]="
                    ('VEHICLES.SEARCH.BY_PLATE' | translate) + ':'
                  "
                  optionLabel="name"
                  [listStyle]="{ height: '200px' }"
                  [disabled]="loading"
                >
                  <ng-template let-car pTemplate="item">
                    <div class="car-item">
                      <img
                        border="0"
                        width="25"
                        height="25"
                        [src]="car.sanitizer_custom_svg"
                        style="display: inline-block; margin: 2px 0 2px 2px"
                      />
                      <label>{{ car.name }}</label>
                    </div>
                  </ng-template>
                </p-listbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p-footer>
      <div
        class="row d-flex justify-content-center"
        style="gap: 10px; padding: 10px"
      >
        <div class="col-4">
          <button
            (click)="displayEditGroup = false"
            type="button"
            class="btn-gl-cancel btn-dark-hover btn-sm w-100"
            [disabled]="loading"
            loading
            style="min-height: 30px"
          >
            Cancelar
          </button>
        </div>
        <div class="col-4">
          <button
            (click)="onConfirmationEdit()"
            type="button"
            class="btn-gl-save btn-dark-hover btn-sm w-100"
            [disabled]="loading"
            loading
            style="min-height: 30px"
          >
            Guardar
          </button>
        </div>
      </div>
    </p-footer>
  </p-dialog>

  <div
    *ngIf="
      isLoadingCollection ||
      isLoadingVehicleService ||
      (isLoadingStateVehicle$ | async)
    "
  >
    <ngx-spinner
      bdColor="rgba(0, 0, 0, 0.8)"
      [name]="nameSpinner"
      size="medium"
      color="#fff"
      type="ball-pulse"
      [fullScreen]="false"
      ><p style="color: white">
        {{ "VEHICLES.MESSAGE.LOADING" | translate }}
      </p></ngx-spinner
    >
  </div>
</div>
